var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center secondary",attrs:{"id":"banner_content"}},[_c('v-spacer'),_c('div',{staticClass:"white--text",attrs:{"id":"app_bar_title"}},[_vm._v("RPD CONNECT WITH US")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }